const imports = [
    { selector: "#imc_auth", module: () => require('../auth/imc_auth.js') },
    { selector: "#user_options", module: () => require('../user/user_app.js') },
  //  { selector: "#user_birthdays", module: () => require('../user/birthday/birthdays.js') },
    { selector: "#imc_filter", module: () => require('../xml_fields/fields.js') },
    { selector: "#imc_file_loader", module: () => require('../file_loader/imc_loader.js') },
];


imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
